export default {"src":"/_next/static/media/ml-dashboard-desktop-full-image.3e7dffcd.svg","height":708,"width":1028,"blurWidth":0,"blurHeight":0};